module.exports = __webpack_public_path__ + "img/line.c6fa9384.png";